module.exports = __webpack_public_path__ + "static/media/blue_button2.cc7a30f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blue_button2.png
// module id = 49
// module chunks = 0